
<div class="modal-long-content">
  <EditForm
    :entities="entities"
    :counter="counter"
    :entity-data="entity"
    :payment-terms="paymentTerms"
    :on-success="handleSuccess"
    :on-cancel="handleFormCancel"
  />
</div>
